// 统一数据接口层
// 当前返回 src/mock 下的模拟数据;后期接入后端时,只需将本文件内的实现替换为 axios 请求即可,
// 页面组件不感知数据来源变化。例如:
//   import axios from 'axios'
//   export function getList(moduleKey, params) {
//     return axios.get(`/api/${moduleKey}/list`, { params }).then(res => res.data)
//   }
import { mockDb, mockReports } from '@/mock/data'

// 模拟网络延迟
function delay(ms = 300) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

// 获取指定模块的列表数据(支持关键字过滤 + 分页)
export async function getList(moduleKey, params = {}) {
  await delay()
  let rows = mockDb[moduleKey] || []
  const keyword = (params.keyword || '').trim()
  if (keyword) {
    rows = rows.filter(row =>
      Object.values(row).some(v => String(v).includes(keyword))
    )
  }
  const page = params.page || 1
  const pageSize = params.pageSize || 10
  return {
    total: rows.length,
    list: rows.slice((page - 1) * pageSize, page * pageSize)
  }
}

// 获取指定报表数据(汇总卡片 + 明细表格)
export async function getReport(reportKey) {
  await delay()
  return mockReports[reportKey] || null
}
